(function () {
  'use strict'

  const SECTION_ID = 'cart-drawer'
  const ADD_EVENT = 'cart:add'
  const UPDATE_EVENT = 'cart:update'
  let previousScrollY = 0
  let appCartSyncTimer
  let appCartSyncRun = 0
  let appCartSyncVersion = 0

  function getRoot () {
    return document.querySelector('[data-cart-drawer]')
  }

  function getDialog () {
    const root = getRoot()
    return root && root.querySelector('[data-cart-drawer-dialog]')
  }

  function getRoutes () {
    const root = getRoot()
    return {
      add: root && root.dataset.cartAddUrl,
      change: root && root.dataset.cartChangeUrl,
      update: root && root.dataset.cartUpdateUrl,
      sectionsUrl: root && root.dataset.sectionsUrl
    }
  }

  function setLoading (loading) {
    const dialog = getDialog()
    if (!dialog) return

    const indicator = dialog.querySelector('[data-cart-drawer-loading]')
    dialog.setAttribute('aria-busy', loading ? 'true' : 'false')
    if (indicator) indicator.hidden = !loading
  }

  function updateHeaderCount (count) {
    const badges = document.querySelectorAll('header .tt-badge-cart')
    badges.forEach(function (badge) {
      badge.textContent = count
      badge.classList.toggle('hide', Number(count) === 0)
    })
  }

  function renderSection (html) {
    if (!html) return false

    const currentRoot = getRoot()
    if (!currentRoot) return false

    const parsed = new window.DOMParser().parseFromString(html, 'text/html')
    const nextRoot = parsed.querySelector('[data-cart-drawer]')
    const currentRendered = currentRoot.querySelector('[data-cart-drawer-rendered]')
    const nextRendered = nextRoot && nextRoot.querySelector('[data-cart-drawer-rendered]')

    if (!nextRoot || !currentRendered || !nextRendered) return false

    currentRendered.replaceWith(document.importNode(nextRendered, true))
    currentRoot.dataset.cartCount = nextRoot.dataset.cartCount || '0'
    updateHeaderCount(currentRoot.dataset.cartCount)
    if (window.jQuery) window.jQuery('body').trigger('refreshCurrency')

    return true
  }

  function refreshCartSection () {
    const url = new URL(getRoutes().sectionsUrl || window.location.pathname, window.location.origin)
    url.searchParams.set('sections', SECTION_ID)
    const version = ++appCartSyncVersion

    return fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart.')
        return response.json()
      })
      .then(function (sections) {
        return version === appCartSyncVersion && renderSection(sections[SECTION_ID])
      })
  }

  function syncAppCart () {
    const root = getRoot()
    if (!root) return

    window.clearTimeout(appCartSyncTimer)
    const run = ++appCartSyncRun
    let lastCount = Number(root.dataset.cartCount)
    const deadline = Date.now() + 8000
    const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'

    function poll () {
      if (run !== appCartSyncRun) return
      fetch(cartRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to read cart.')
          return response.json()
        })
        .then(function (cart) {
          if (run !== appCartSyncRun) return
          if (cart.item_count !== lastCount) {
            lastCount = cart.item_count
            return refreshCartSection().then(function (updated) {
              if (updated && run === appCartSyncRun) openDrawer()
            })
          }
        })
        .catch(function () {})
        .finally(function () {
          if (run === appCartSyncRun && Date.now() < deadline) {
            appCartSyncTimer = window.setTimeout(poll, 500)
          }
        })
    }

    poll()
  }

  function openDrawer () {
    const dialog = getDialog()
    if (!dialog || dialog.open) return

    const discountInput = dialog.querySelector('[data-cart-discount-form] [name="discount"]')
    if (discountInput) discountInput.form.querySelector('[type="submit"]').disabled = !discountInput.value.trim()

    previousScrollY = window.scrollY
    document.body.style.width = '100%'
    document.body.style.position = 'fixed'
    document.body.style.top = '-' + previousScrollY + 'px'
    dialog.showModal()
    document.documentElement.classList.add('db-cart-drawer-open')
  }

  function closeDrawer () {
    const dialog = getDialog()
    if (!dialog || !dialog.open || dialog.classList.contains('db-cart-drawer--closing')) return

    dialog.classList.add('db-cart-drawer--closing')
    window.setTimeout(function () {
      dialog.close()
      dialog.classList.remove('db-cart-drawer--closing')
      document.documentElement.classList.remove('db-cart-drawer-open')
      document.body.style.width = ''
      document.body.style.position = ''
      document.body.style.top = ''
      window.scrollTo(0, previousScrollY)
    }, 220)
  }

  function cartRequest (url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(Object.assign({}, payload, {
        sections: SECTION_ID,
        sections_url: getRoutes().sectionsUrl || window.location.pathname
      }))
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status || data.errors) {
          throw new Error(data.description || data.message || data.errors || 'Unable to update cart.')
        }
        return data
      })
    })
  }

  function dispatchCartEvent (eventName, response) {
    document.dispatchEvent(new window.CustomEvent(eventName, {
      detail: {
        cart: response,
        sections: response.sections || {}
      }
    }))
  }

  function updateLine (line, quantity) {
    const routes = getRoutes()
    if (!routes.change) return

    setLoading(true)
    cartRequest(routes.change, {
      id: line.dataset.lineKey,
      quantity
    }).then(function (response) {
      dispatchCartEvent(UPDATE_EVENT, response)
    }).catch(function (error) {
      const errorElement = line.querySelector('[data-cart-line-error]')
      if (errorElement) {
        errorElement.textContent = error.message
        errorElement.hidden = false
      }
    }).finally(function () {
      setLoading(false)
    })
  }

  function addRecommendation (button) {
    const addUrl = getRoutes().add
    const variantId = Number(button.dataset.variantId)
    if (!addUrl || !variantId || button.disabled) return

    button.disabled = true
    setLoading(true)
    cartRequest(addUrl, {
      items: [{ id: variantId, quantity: 1 }]
    }).then(function (response) {
      dispatchCartEvent(ADD_EVENT, response)
      if (!response.sections || !response.sections[SECTION_ID]) return refreshCartSection()
    }).catch(function (error) {
      const errorElement = button.closest('.db-cart-drawer__recommendations').querySelector('[data-cart-recommendation-error]')
      if (errorElement) {
        errorElement.textContent = error.message
        errorElement.hidden = false
      }
    }).finally(function () {
      button.disabled = false
      setLoading(false)
    })
  }

  function applyDiscount (form) {
    const routes = getRoutes()
    if (!routes.update) return

    const input = form.querySelector('[name="discount"]')
    const errorElement = form.querySelector('[data-cart-discount-error]')
    if (!input || !input.value.trim()) return

    setLoading(true)
    cartRequest(routes.update, {
      discount: input.value.trim()
    }).then(function (response) {
      dispatchCartEvent(UPDATE_EVENT, response)
    }).catch(function (error) {
      if (errorElement) {
        errorElement.textContent = error.message
        errorElement.hidden = false
      }
    }).finally(function () {
      setLoading(false)
    })
  }

  function appendSectionParams (data) {
    const routes = getRoutes()
    const sectionParams = 'sections=' + encodeURIComponent(SECTION_ID) +
      '&sections_url=' + encodeURIComponent(routes.sectionsUrl || window.location.pathname)

    if (typeof data === 'string') {
      return data ? data + '&' + sectionParams : sectionParams
    }

    const result = Object.assign({}, data || {})
    result.sections = SECTION_ID
    result.sections_url = routes.sectionsUrl || window.location.pathname
    return result
  }

  function installAjaxPrefilter () {
    if (!window.jQuery || typeof window.jQuery.ajaxPrefilter !== 'function') return

    window.jQuery.ajaxPrefilter(function (options) {
      if (!options.url || options.url.indexOf('/cart/add') === -1) return
      if (typeof options.data === 'string' && /application\/json/i.test(options.contentType || '')) {
        options.data = JSON.stringify(appendSectionParams(JSON.parse(options.data)))
      } else {
        options.data = appendSectionParams(options.data)
      }
    })

    window.jQuery(document)
      .off('ajaxSuccess.dbCartDrawer')
      .on('ajaxSuccess.dbCartDrawer', function () {
        const xhr = arguments[1]
        const settings = arguments[2]
        if (!settings || !settings.url || settings.url.indexOf('/cart/add') === -1) return

        const response = xhr && xhr.responseJSON
        if (!response || !response.sections) return
        dispatchCartEvent(ADD_EVENT, response)
      })
  }

  function restoreProductBundlePlacement () {
    const anchorSelector = '#tt-pageContent [data-product-frequently-bought-anchor]'
    const bundleSelector = '.cbb-frequently-bought-container.cbb-product-page-view'
    if (!document.querySelector(anchorSelector)) return

    function moveBundle () {
      const anchor = document.querySelector(anchorSelector)
      if (!anchor) return

      document.querySelectorAll(bundleSelector).forEach(function (bundle) {
        if (bundle.parentElement !== anchor) anchor.appendChild(bundle)
      })
    }

    moveBundle()
    if (window.MutationObserver) {
      // The app may insert or reinsert its widget anywhere in the document after page load.
      new window.MutationObserver(function (mutations) {
        const hasBundle = mutations.some(function (mutation) {
          if (mutation.type === 'attributes') return mutation.target.matches(bundleSelector)

          return Array.from(mutation.addedNodes).some(function (node) {
            return node.nodeType === 1 && (
              node.matches(bundleSelector) || node.querySelector(bundleSelector) ||
              node.matches(anchorSelector) || node.querySelector(anchorSelector)
            )
          })
        })

        if (hasBundle) moveBundle()
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] })
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-app-cart-sync] button, [data-app-cart-sync] a, [data-app-cart-sync] [role="button"], [data-app-cart-sync] input[type="submit"]')) {
      syncAppCart()
    }

    const openButton = event.target.closest('[data-cart-drawer-open]')
    if (openButton) {
      event.preventDefault()
      event.stopImmediatePropagation()
      openDrawer()
    }
  }, true)

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer()
      return
    }

    const recommendationButton = event.target.closest('[data-cart-recommendation-add]')
    if (recommendationButton) {
      event.preventDefault()
      addRecommendation(recommendationButton)
      return
    }

    const dialog = getDialog()
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect()
      const clickedOutside = event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      if (clickedOutside) closeDrawer()
      return
    }

    const quantityButton = event.target.closest('[data-cart-quantity-change]')
    if (quantityButton) {
      const quantityLine = quantityButton.closest('[data-cart-line]')
      if (quantityLine) updateLine(quantityLine, Number(quantityButton.dataset.quantity))
      return
    }

    const removeButton = event.target.closest('[data-cart-remove]')
    if (removeButton) {
      const removeLine = removeButton.closest('[data-cart-line]')
      if (removeLine) updateLine(removeLine, 0)
    }
  })

  document.addEventListener('submit', function (event) {
    const discountForm = event.target.closest('[data-cart-discount-form]')
    if (!discountForm) return

    event.preventDefault()
    applyDiscount(discountForm)
  })

  document.addEventListener('input', function (event) {
    const input = event.target.closest('[data-cart-discount-form] [name="discount"]')
    if (!input) return

    input.form.querySelector('[type="submit"]').disabled = !input.value.trim()
    const errorElement = input.form.querySelector('[data-cart-discount-error]')
    if (errorElement) errorElement.hidden = true
  })

  document.addEventListener('cancel', function (event) {
    if (event.target !== getDialog()) return
    event.preventDefault()
    closeDrawer()
  }, true)

  document.addEventListener(ADD_EVENT, function (event) {
    const html = event.detail.sections[SECTION_ID]
    renderSection(html)
  })

  document.addEventListener(UPDATE_EVENT, function (event) {
    renderSection(event.detail.sections[SECTION_ID])
  })

  function init () {
    installAjaxPrefilter()
    restoreProductBundlePlacement()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
